import './ErrorPage.css'

function ErrorPage() {
  return (
    <div className='errMessege'>Sorry...Page Not Found</div>
  )
}

export default ErrorPage
